module.exports = __webpack_public_path__ + "static/media/integratedShelf-H1.81a84aee.png";